{
  "sendSMS": "Send SMS",
  "receiverLabel": "Mottaker",
  "receiversDescription": "Velg en eller flere mottakere",
  "allRecipientsSelected": "Listen er tom - alle mottakere er valgt",
  "messageLabel": "Melding",
  "messageDescription": "Skriv meldingen du ønsker å sende",
  "messagePlaceholder": "Skriv her...",
  "forestOwner": "Skogeier",
  "representative": "Representant",
  "noPhone": "Ingen telefon",
  "recipientsRequired": "Mottakere må velges",
  "messageRequired": "Meldingen kan ikke være tom. Skriv inn teksten du vil sende",
  "missingPhoneTitle": "Telefonnummer mangler",
  "missingPhoneDescription": "For å kunne sende SMS til skogeier eller representant må telefonnummer være registrert. Legg inn telefonnummer under «Endre skogeieropplysninger» på oversiktssiden.",
  "longMessageWarningTitle": "SMS kostnaden øker ved lange meldinger!",
  "longMessageWarningDescription": "Meldingen overskrider 160 tegn, som er grensen for én SMS. Kostnaden øker jo flere SMS-er den deles opp i. Mottakeren ser den likevel som én sammenhengende melding.",
  "messageTooLong": "Meldingen er for lang. Maks grense for lengde er 800 Tegn / 5 SMS.",
  "successTitle": "Meldingen er sendt",
  "successDescription": "Sendingen av meldingen var vellykket",
  "characters": "tegn",
  "sms": "SMS",
  "sendFailed": "Kunne ikke sende SMS",
  "tryAgainLater": "Vennligst prøv igjen senere."
}
